import React from "react";

/**
 * Shared progress stepper for investigation form pages.
 *
 * @param {{ steps: Array<{number, title, description}>, currentStep: number, onStepClick: (n: number) => void }} props
 */
const InvestigationStepper = ({ steps, currentStep, onStepClick }) => (
  <div className="stepper-card">
    <div className="stepper-row">
      {steps.map((step, index) => (
        <div className="stepper-item" key={step.number}>
          <div className="stepper-content">
            <div
              className={`stepper-circle ${
                currentStep >= step.number
                  ? "stepper-circle-active"
                  : "stepper-circle-inactive"
              }`}
              onClick={() => onStepClick(step.number)}
            >
              {step.number}
            </div>
            <p
              className={`stepper-label ${
                currentStep >= step.number
                  ? "stepper-label-active"
                  : "stepper-label-inactive"
              }`}
            >
              {step.title}
            </p>
            <p className="stepper-desc">{step.description}</p>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`stepper-line ${
                currentStep > step.number
                  ? "stepper-line-active"
                  : "stepper-line-inactive"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  </div>
);

export default InvestigationStepper;
